import React, { useContext, useState } from 'react';
import { Typography } from 'antd';
import { IoWarningOutline } from 'react-icons/io5';
import AlertCard from './AlertCard';
import { ALERT_CATEGORY, triggerAlert } from '../../mqtt/aws';
import { SimulatorContext } from 'store/context';

const { Text } = Typography;

const CriticalMalfunctionAlert = ({ messageApi, onTriggered }) => {
  const { stsToken: credentials, vehicleSimulatorSettings: { serialNo, vehicleKey } } = useContext(SimulatorContext);
  const [loading, setLoading] = useState(false);

  const triggerMalfunctionAlert = async () => {
    setLoading(true);
    await triggerAlert({ serialNo, vehicleKey, actual: '', threshold: '' }, credentials, ALERT_CATEGORY.CRITICAL_MALFUNCTION_ALERT)
      .then(() => { messageApi.success('Critical malfunction alert triggered successfully'); onTriggered?.({ success: true, value: null }); })
      .catch(() => { messageApi.error('Failed to trigger malfunction alert'); onTriggered?.({ success: false, value: null }); })
      .finally(() => setLoading(false));
  };

  return (
    <AlertCard
      index={8}
      title="Critical Malfunction"
      icon={<IoWarningOutline />}
      iconBg="#fff5f5"
      iconColor="#ef4444"
      onTrigger={triggerMalfunctionAlert}
      triggerLabel="Trigger Malfunction Alert"
      loading={loading}
    >
      <div
        style={{
          padding: '10px 12px',
          borderRadius: 8,
          background: '#fff5f5',
          border: '1px solid #fca5a5',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#ef4444', flexShrink: 0 }} />
        <Text style={{ fontSize: 12, color: '#dc2626', fontWeight: 500 }}>
          Triggered on critical vehicle malfunction detected
        </Text>
      </div>
    </AlertCard>
  );
};

export default CriticalMalfunctionAlert;
